<script setup lang="ts">
import { computed } from "vue";
import MicIcon from "../../../assets/icons/microphone.svg"
import RestartIcon from '../../../assets/icons/restart.svg'
import { useI18n } from "petite-vue-i18n";
import { TEXT } from "../../../configs/text";
import { utils } from "../../../utils";
import { PlayIcon, StopIcon } from "@heroicons/vue/16/solid";

interface Props {
    state: 'disabled' | 'ready' | 'retry' | 'recording' | 'recorded'
    peak?: number[]
    remaining?: number
}
const { state, remaining = 0, peak = [] } = defineProps<Props>()

const recordStateKey = computed<string>(() => {
    const stateKeyMap = {
        disabled: TEXT.record,
        ready: TEXT.record,
        retry: TEXT.retry,
        recording: '', // not in use
        recorded: TEXT.submit_vocab
    }
    return stateKeyMap[state]
})

const emit = defineEmits(['click', 'play', 'stop', 'restart'])

const { t } = useI18n()
</script>

<template>
    <div v-if="state === 'recording' || state === 'recorded'" class="flex items-center gap-4 mb-4">
        <div @click="emit(state === 'recording' ? 'click' : remaining === 0 ? 'play' : 'stop')" class="rounded-full p-2 bg-sky-500 flex items-center justify-center cursor-pointer">
            <StopIcon v-if="state === 'recording'" class="size-5 fill-white" />
            <template v-else>
                <PlayIcon v-if="remaining === 0" class="size-5 fill-white" />
                <StopIcon v-else class="size-5 fill-white" />
            </template>
        </div>
        <div class="flex items-center gap-2 rounded-full bg-gray-100 p-2">
            <div v-if="state === 'recording'" class="size-3 bg-red-500 rounded-full"></div>
            <div>{{ utils.formatSecondsToMinuteSeconds(remaining) }}</div>
            <div class="flex items-center gap-1 h-5">
                <div v-for="value in peak" class="bg-black w-0.5 rounded-full" :style="{ height: `calc(${value * 100}% + 2px)` }"></div>
            </div>
        </div>
        <RestartIcon v-if="state === 'recorded'" class="size-5 cursor-pointer brightness-0" @click="emit('restart')" />
    </div>
    <div v-if="state !== 'recording'" class="flex flex-col items-center gap-1 " @click="emit('click')">
        <div class="flex items-center justify-center gap-2 box-content border border-b-4 px-4 py-2 rounded-2xl cursor-pointer relative overflow-hidden text-white" :class="{
            'bg-sky-500 border-sky-700': state !== 'disabled',
            'bg-gray-400 border-gray-500 !cursor-not-allowed': state === 'disabled'
        }">
            <component :is="state === 'retry' ? RestartIcon : MicIcon" v-if="state !== 'recorded'" class="size-5"></component>
            <div class="text-white">{{ t(recordStateKey) }}</div>
        </div>
    </div>
</template>